import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { TSelectFilterGroupInfo } from '../filter/model/ui-filter.types';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'monorepo-searchbar-with-api-suggestions-container',
  templateUrl: './searchbar-with-api-suggestions-container.component.html',
  styleUrls: ['./searchbar-with-api-suggestions-container.component.scss'],
})
export class SearchbarWithAPISuggestionsContainerComponent implements OnInit {
  @Input() isDisabled: boolean | undefined = undefined;
  @Input() placeholder = 'Search';
  @Input() multiSelect = true;
  @Input() set searchAPIResults(value: TSelectFilterGroupInfo['items']) {
    this._searchAPIResults = value;
    if (value.length) this.showSuggestions = true;
    this.searchResultsNotFound = !!this.searchText.length && !value.length;
  }
  virtualScroll: TSelectFilterGroupInfo['virtualScroll'] = {
    itemSize: 40,
    minBufferPx: window.screen.height / 2,
    maxBufferPx: window.screen.height / 2,
  };

  @Output() searchInputChangeEvent = new EventEmitter<string>();
  @Output() searchEvent = new EventEmitter<string>();
  @Output() applySearchResultSelect = new EventEmitter<TSelectFilterGroupInfo['items']>();

  searchText = '';
  searchResultsNotFound = false;
  showSuggestions = false;
  _searchAPIResults: TSelectFilterGroupInfo['items'] = [];

  constructor(translate: TranslateService) {}

  ngOnInit(): void {}

  onSearchInputChange($event: Event) {
    this.searchText = ($event.target as HTMLInputElement)?.value;
    this.searchInputChangeEvent.emit(this.searchText);
  }

  handleSearchEvent($event: Event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.searchEvent.emit(this.searchText);
  }

  onClearSearchEvent() {
    this.searchText = '';
    this.showSuggestions = false;
    this.searchEvent.emit(this.searchText);
  }

  handleOutsideClick() {
    this.showSuggestions = false;
  }

  /**
   * Invoked when a suggestion from the suggestion-container is selected.
   * It updates the _liftedFormModel and emits formUpdateEvent.
   * @param item
   * @param existingInput
   * @param index
   */
  onSuggestionSelection(item: string | number) {
    // if (existingInput.input.type === 'SEARCH') {
    //   const updatedInput = {
    //     ...existingInput,
    //     input: {
    //       ...existingInput.input,
    //       value: item,
    //       options: undefined,
    //       showSuggestions: false,
    //     },
    //   };
    //   this.#updateAndEmitFormEvent(updatedInput, index);
    // }
  }

  onClearAll() {
    this._searchAPIResults = this._searchAPIResults.map((res) => ({ ...res, isSelected: false }));
  }

  onApply() {
    this.searchText = '';
    this.showSuggestions = false;
    console.log('on apply', this._searchAPIResults);
    const selectedData = this._searchAPIResults.filter((res) => res.isSelected);
    this.applySearchResultSelect.emit(selectedData);
  }
}
